import {
    iconRequest,
    iconClient,
    iconReports,
    iconCalculator,
    iconReportsDefault,
    iconCertificate,
    iconSearch,
    iconParameters,
    iconDocs,
    iconParametersGyg,
    iconEmployeesCredits,
    iconSendPayment,
    iconPolizas,
    iconWarranty,
} from '../defaultValues';

const data = {
    role_948e82899c354e6789a4c7b76b2b5262: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'gogo2',
            icon: iconEmployeesCredits,
            label: 'Créditos Empleados',
            to: '/app/employees',
        },
        // {
        //     id: 'neww',
        //     icon: iconWarranty,
        //     label: 'Garantía Vehicular',
        //     to: '/app/warranty',
        // },

        {
            id: 'neww',
            icon: iconWarranty,
            label: 'Garantía Vehicular',
            subs: [
                {
                    id: 'gestiona-garantias',
                    icon: iconReportsDefault,
                    label: 'Gestionar',
                    to: '/app/warranty',
                },
                {
                    id: 'consulta-garantias',
                    icon: iconReportsDefault,
                    label: 'Consultar',
                    to: '/app/radicationWarranty',
                },
            ],
        },

        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'newoptions',
            icon: iconPolizas,
            label: 'Operaciones',
            to: '/app/calculator',
            subs: [
                {
                    id: 'reprocess',
                    icon: iconPolizas,
                    label: 'Reprocesar desembolso',
                    to: '/app/ReprocessDisbursements',
                },
            ],
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'payments',
            icon: iconSendPayment,
            label: 'Envío de Comprobantes',
            to: '/app/vouchers',
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
                {
                    icon: iconClient,
                    label: 'Terceros',
                    to: '/app/reports/reportThirds',
                },
            ],
        },

        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconCalculator,
                    label: 'Simulador de Créditos',
                    to: '/app/calculator',
                },
                {
                    icon: iconCalculator,
                    label: 'Calculadora R&R',
                    to: '/app/reports/calculatorRefinancing',
                },
            ],
        },
        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    id: 'gyg',
                    icon: iconParametersGyg,
                    label: 'G&G',
                    to: '/app/gyg/parameterGyg',
                },
                {
                    id: 'terceros',
                    icon: iconReportsDefault,
                    label: 'Terceros',
                    to: '/app/socialReasons',
                },
                {
                    id: 'banck-accounts',
                    icon: iconReportsDefault,
                    label: 'Cuentas bancarias',
                    to: '/app/bankAccounts',
                },
            ],
        },
        {
            id: 'documentos',
            icon: iconDocs,
            label: 'Documentos',
            to: '/app/calculator',
            subs: [
                {
                    id: 'certificados',
                    icon: iconCertificate,
                    label: 'Certificados',
                    to: '/app/reports/peaceAndSafe',
                    subs: [
                        {
                            id: 'fng-reports',
                            icon: iconCertificate,
                            label: 'Registrar',
                            to: '/app/reports/peaceAndSafe',
                        },
                        {
                            id: 'fng-reports',
                            icon: iconCertificate,
                            label: 'Consultar',
                            to: '/app/reports/checkCertificates',
                        },
                    ],
                },
            ],
        },
    ],
};
export default data;
